export default class NodeRadiusCreator {
	// Public:
	constructor(cParams) {
		this.saveParams(cParams);
	}

	compute() {
		// this.normalizeSize();
		this.scaleZeroToOne();
		this.computeRadius();
	}

	// Private:
	saveParams(cParams) {
		this._nodes = cParams.nodes;
		this._nodesSettings = cParams.nodesSettings;
	}

	normalizeSize() {
		let nodes = this._nodes;
		let weights = [];
		nodes.forEach(node => {
			let weight = node.weight;
			if (weight) weights.push(weight);
		});
		let max = getMaxOfArray(weights);
		nodes.forEach(node => {
			node.weight = 0
			if (max > 0 && node.weight) {
				let weight = node.weight / max;
				if (!Number.isNaN(weight)) node.weight = weight
			}
		});
	}


	scaleZeroToOne() {
		let nodes = this._nodes;
		let weights = [];
		nodes.forEach(node => {
			let weight = node.weight;
			if (weight) weights.push(weight);
		});
		let max = getMaxOfArray(weights);
		let min = getMinOfArray(weights);
		nodes.forEach(node => {
			if (max === 0 || !node.weight) {
				node.weight = 0;
			} else {
				node.weight = (node.weight - min) / (max - min);
			}
		});
	}

	computeRadius() {
		let nodes = this._nodes;
		var cParams = this._nodesSettings;
		nodes.forEach(node => {
			let R = null;
			let type = node.type;
			switch (type) {
				case "master":
					R = cParams.masterRadius;
					break;
				case "slave":
					let formula = cParams.slaveRadiusFormula;
					R = this.applyFormula(node, formula);
					break;
				default:
					console.error("Invalid node type: " + String(type));
					break;
			}
			node.radius = R;
		});
	}

	applyFormula(node, formula) {
		let N = this._nodes.length
		// let d = this.computeDiversityFactor(node.ownersIds);
		let x = node.weight;
		if (!x) {
			x = 0;
		}
		if (Number.isNaN(x)) {
			x = 0;
		}
		let k = formula.proportional;
		let n = formula.exponent;
		let C = formula.constant;
		let f = (k * Math.pow(x, n) * ((N / 10) ^ (1 /5))) + C;
		return f;
	}

	computeDiversityFactor(ownersIds) {
		let nOwners = ownersIds.length;
		let diversity = nOwners;
		return diversity;
	}
}

function getMaxOfArray(numArray) {
	return Math.max.apply(null, numArray);
}

function getMinOfArray(numArray) {
	return Math.min.apply(null, numArray);
}